const DATE_ISO_8601_REGEX: RegExp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[-+]\d{2}:\d{2})$/
const DATE_ISO_8601_NO_TZ_REGEX: RegExp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/
const DATE_ISO_8601_NO_TZ_REGEX_NO_T: RegExp = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?(\+\d{2}:\d{2})?$/

export function dateFromServer(value: string): Date {
  if (DATE_ISO_8601_REGEX.test(value)) return new Date(value)
  if (DATE_ISO_8601_NO_TZ_REGEX.test(value)) return new Date(`${value}Z`)
  if (DATE_ISO_8601_NO_TZ_REGEX_NO_T.test(value)) return new Date(`${value}Z`)
  throw new Error(`Invalid date format '${value}' !`);
}

export function dateToString(datetime: Date): string {
  return datetime.toLocaleDateString('fr-FR', {timeZone: 'Europe/Paris'})
}

export function timeToString(datetime: Date): string {
  return datetime.toLocaleTimeString('fr-FR', {timeZone: 'Europe/Paris'})
}

export function datetimeToString(datetime: Date): string {
  return `${dateToString(datetime)} @ ${timeToString(datetime)}`
}

export function convertWithTimezone(value: string): string {
  if (DATE_ISO_8601_NO_TZ_REGEX_NO_T.test(value))
    return value.replace(' ','T')+'+02:00'
  if (DATE_ISO_8601_NO_TZ_REGEX.test(value))
    return value+'+02:00'
  if (DATE_ISO_8601_REGEX.test(value))
    return value
  throw new Error(`Invalid date format '${value}' !`);
}